module.exports = __webpack_public_path__ + "static/media/transform.daf855cc.svg";